import React from 'react'

const SvgContrast = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12 20V4c4.411 0 8 3.588 8 8s-3.589 8-8 8zm0-18C6.486 2 2 6.485 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-5.515-4.486-10-10-10z' />
  </svg>
)

export default SvgContrast
